import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {CreManagementComponent} from "./components/search/cre-management.component";
import {CreManagementSearchFormComponent} from "./components/search/cre-management-search-form/cre-management-search-form.component";
import {CreManagementSearchResultsComponent} from "./components/search/cre-management-search-results/cre-management-search-results.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UIComponentsModule} from "../uicomponents/uicomponents.module";
import {PathwayRequirementsModalComponent} from "./components/search/cre-management-search-results/pathway-requirements-modal/pathway-requirements-modal.component";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatExpansionModule} from "@angular/material/expansion";
import {PathwayComponent} from "./components/search/cre-management-search-results/pathway/pathway.component";
import {CdkTableModule} from "@angular/cdk/table";
import {MatInputModule} from "@angular/material/input";
import {MatBadgeModule} from "@angular/material/badge";
import {DragDropModule} from "@angular/cdk/drag-drop";
import "./cre-management.config";
import "./cre-management.downgrades";

@NgModule({
    declarations: [
        CreManagementComponent,
        CreManagementSearchFormComponent,
        CreManagementSearchResultsComponent,
        PathwayRequirementsModalComponent,
        PathwayComponent,
    ],
    providers: [],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UIComponentsModule,
        MatButtonModule,
        MatDialogModule,
        MatSortModule,
        MatTableModule,
        MatPaginatorModule,
        MatExpansionModule,
        CdkTableModule,
        MatInputModule,
        MatBadgeModule,
        DragDropModule
    ],
})
export class CREManagementModule {
}
